import { useEffect, useState } from 'react';

import { useUserContext } from '~/contexts/UserContext';
import type { AccountVendorView } from '~/types/responseTypes';
import ApiService from '~/util/apiService';

interface UseBookedVendorsReturnType {
  loaded: boolean;
  bookedVendors: AccountVendorView[];
}

const useBookedVendors = (): UseBookedVendorsReturnType => {
  const [bookedVendors, setBookedVendors] = useState<AccountVendorView[]>([]);

  const userContext = useUserContext();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (userContext) {
      if (!userContext.is_guest) {
        ApiService.get('/web-marketplace-api/v1/account/vendors')
          .then((data: AccountVendorView[]) => {
            setBookedVendors(data);
            setLoaded(true);
          })
          .catch(() => {
            // Catch handles 404 / 500 for no account id
            setBookedVendors([]);
            setLoaded(true);
          });
      } else {
        setLoaded(true);
      }
    }
  }, [userContext]);

  return {
    loaded,
    bookedVendors,
  };
};

export default useBookedVendors;
